<!-- ------------------ SIGNATURE CLIENT ------------------ -->
<template>
      <v-expansion-panel>
        <v-expansion-panel-header disable-icon-rotate>
          {{ getEtatAvancementDate('2000').message }}
          <template v-slot:actions>
            <v-icon :color="getEtatAvancementDate('2000').couleur">
              {{ getEtatAvancementDate('2000').icone }}
            </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
        <v-list class="mx-0">    
          <x-avancement-jalon-icone-texte 
            v-for="(item, index) in jalons"
            :key="index"            
            :champ_recherche="item"
            ></x-avancement-jalon-icone-texte>                                                               
        </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
</template>

<script>
import { mapGetters } from 'vuex';
import XAvancementJalonIconeTexte from './X-avancement-jalon-icone-texte.vue';

export default {
  name: "X-avancement-ordonnancement",
  components: { XAvancementJalonIconeTexte},
  data() {
    return {
      jalons: [
        'precommande_1erepose_termine_le','lancementfab_1erepose_termine_le','lancementfab_finition_termine_le'
      ],
      commandes: false,
      loading: false      
      
    }
  },
  methods: {

  },
  computed: {
    ...mapGetters('chantier', {   
      getEtatAvancementDate: 'getEtatAvancementDate'
    }),   
  },
}
</script>

<style scoped>

</style>